/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  
  /**
   * Модель для списка чекбоксов в фильтрах.
   */
  app.Filters.CheckboxList = app.Model.extend({
    defaults: {
      object: false,
      element: false,
      mas: null,
      view: null,
    },
    viewClass: app.Filters.CheckboxListView,
    itemClass: app.Filters.Checkbox,
    /**
     * @inheritDoc
     */
    initialize: function () {
      this.set('mas', []);
      var object = this.get('object');
      object.hasAtLeastFiveSelectable = _.filter(object.values, 'selectable').length >= 5;
      this.view = new this.viewClass({
        model: this,
        object: object,
        parent: this.get('element'),
      });
      object.values = $.map(object.values, function (value) {
        return [value];
      });

      var firstOwnTrademarkIsSet = false,
          firstOtherTrademarkIsSet = false;
      for (var i in object.values) {
        if (object.values.hasOwnProperty(i)) {
          object.values[i].title = object.values[i].name;
          object.values[i].name = object.values[i].id;
          object.values[i].count = _.isNull(object.values[i].count) ? 0 : object.values[i].count;
          if (object.name === 'trademark' && !firstOtherTrademarkIsSet) {
            if (!firstOwnTrademarkIsSet && object.values[i].is_exclusive) {
              object.values[i].first_own_trademark = true;
              firstOwnTrademarkIsSet = true;
            }
            if (firstOwnTrademarkIsSet && !object.values[i].is_exclusive) {
              object.values[i].first_other_trademark = true;
              firstOtherTrademarkIsSet = true;
            }
          }
          this.get('mas').push(new this.itemClass(
            {
              object: object.values[i],
              className: object.class_name,
            },
            {
              withoutView: true,
            }
          ));
        }
      }
      this.view.renderList();
      this.view.sortSelectedFilters(object.simpleSortSelected);
    },
    /**
     * Формирует объект с параметрами фильтрации
     * @returns {Object} Параметры фильтрации
     */
    toQuery: function (obj) {
      var list = this.get('mas'),
        mas = [],
        name = this.get('object').name;
      
      if (this.get('object').key) {
        name = this.get('object').key;
      }
      
      for (var i in list) {
        if (list.hasOwnProperty(i)) {
          list[i].toQuery(mas);
        }
      }
      if (mas.length) {
        var result = this.prepareQuery(mas);
        if (_.isArray(result)) {
          obj[name] = _.union(obj[name], result);
        } else if (result) {
          obj[name] = result;
        }
      }
      return obj;
    },
    /**
     * Подготовка значений параметра фильтрации
     * @param {*} mas
     * @return {*}
     */
    prepareQuery: function (mas) {
      return mas;
    }
  });
})(jQuery);

}.call(window));